import axios from "axios";
import {config} from '../config/client'
import authHeader from '../services/auth-header';


const API_URL = config.endpoint + "/quiz";

const getQuizzes = async (author) => {
    // const response = await axios.POST(API_URL+"es");
    // return response.data;
    const response = await axios.post(API_URL+"es", {
        author
    })
    return response.data;
}

const quiz_progress_teacher = async (teacher, student) => {
    var params = new URLSearchParams();
    params.append("teacher", teacher);
    params.append("student", student);
    var request = {
        params: params
    };
    const response = await axios.get(config.endpoint + "/quiz_progress_teacher" , request);
    return response.data;
}

const get_teacher_students = async (author) => {
    var params = new URLSearchParams();
    params.append("teacher", author);
    var request = {
        params: params
    };
    const response = await axios.get(config.endpoint + "/teacher_students" , request);
    return response.data;
}

const getQuiz = async () => {
    const response = await axios.get(API_URL + {quiz_id});
    return response.data;
}

const getQuizEdit = async (author, quiz_id) => {
    var params = new URLSearchParams();
    params.append("author", author);
    params.append("quiz_id", quiz_id);
    var request = {
        params: params
    };
    const response = await axios.get(API_URL + "/edit" , request);
    return response.data;
}

const postQuizEdit = async (quiz_obj) => {
    await axios.post(API_URL + "/edit", quiz_obj);
}

const takeQuiz = async (author, quiz_id, numQuestions) => {
    const response = await axios.post(API_URL + "/take", {
        author, quiz_id, numQuestions
    });
    return response.data;
}

const takeQuizUpdate = async (author, quizAttemptId, questionId) => {
    const response = await axios.post(API_URL + "/update_attempt", {
        author, quizAttemptId, questionId
    });
    return response;
}

const submitQuiz = async (quiz_attempt_id) => {
    await axios.delete(API_URL + "/submit/" + quiz_attempt_id);
}

const createQuiz = async (quiz_obj) => {
    await axios.post(API_URL + "/create", quiz_obj);
}

// const deleteQuiz = async (quiz_obj) => {
//     await axios.post(API_URL + "/delete", quiz_obj)
// }

const deleteQuiz = async (quizId) => {
    const response = await fetch(`${config.endpoint}/quiz/delete`, {
      method: 'DELETE',
      headers: {
        ...authHeader(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ quizId })
    });

    if (!response.ok) {
      throw new Error('Failed to delete quiz');
    }

    return response.json();
  };

const createQuizQuestion = async (quiz_qn_obj) => {
    const response = await axios.post(API_URL + "/question/create", quiz_qn_obj);
    return response.data;
}

const editQuizQuestion = async (quiz_qn_obj) => {
    const response = await axios.post(API_URL + "/question/edit", quiz_qn_obj);
    return response.data;
}

const deleteQuizQuestion = async (quiz_qn_obj) => {
    const response = await axios.post(API_URL + "/question/delete", quiz_qn_obj);
    return response.data;
}

const createQuizJson = async (quizJsonData) => {
    return axios.post(API_URL + "/create_json", quizJsonData, { headers: authHeader() });
};


export default {
    getQuiz, getQuizzes, takeQuiz, submitQuiz, createQuiz, createQuizQuestion,
    getQuizEdit, postQuizEdit, editQuizQuestion, deleteQuizQuestion, deleteQuiz, takeQuizUpdate,
    get_teacher_students, quiz_progress_teacher,
    createQuizJson
}